import * as React from 'react';

const stop = (e: React.SyntheticEvent): void => e.stopPropagation();
const blockEverything = {
  // Clipboard Events
  onCopy: stop,
  onCut: stop,
  onPaste: stop,

  // Input Events
  onCompositionEnd: stop,
  onCompositionStart: stop,
  onCompositionUpdate: stop,
  onSelect: stop,

  // Mouse Events
  onAuxClick: stop,
  onClick: stop,
  onContextMenu: stop,
  onDoubleClick: stop,

  onDrag: stop,
  onDragEnd: stop,
  onDragEnter: stop,
  onDragExit: stop,
  onDragLeave: stop,
  onDragOver: stop,
  onDragStart: stop,
  onDrop: stop,

  onMouseDown: stop,
  onMouseEnter: stop,
  onMouseLeave: stop,
  onMouseMove: stop,
  onMouseOut: stop,
  onMouseOver: stop,
  onMouseUp: stop,

  // Key Events
  onKeyDown: stop,
  onKeyPress: stop,
  onKeyUp: stop,

  // Touch Events
  onTouchCancel: stop,
  onTouchEnd: stop,
  onTouchMove: stop,
  onTouchStart: stop,

  // Pointer Events
  onPointerDown: stop,
  onPointerMove: stop,
  onPointerUp: stop,
  onPointerCancel: stop,
  onPointerEnter: stop,
  onPointerLeave: stop,
  onPointerOver: stop,
  onPointerOut: stop,

  // Focus Events (they bubble in React!)
  // disabled for TFSID 739813 and 740525 onFocus: stop,
  onBlur: stop,

  // Form Events
  onBeforeInput: stop,
  onChange: stop,
  onInput: stop,
  onReset: stop,
  onSubmit: stop,

  // Wheel Events
  onWheel: stop,

  // Animation Events
  onAnimationStart: stop,
  onAnimationEnd: stop,
  onAnimationIteration: stop,
  onTransitionEnd: stop,
};

export interface PortalEventTrapProps extends Pick<React.DOMAttributes<HTMLDivElement>, keyof typeof blockEverything> { }
/** Prevents https://reactjs.org/docs/portals.html#event-bubbling-through-portals */
export const PortalEventTrap: React.FC<PortalEventTrapProps> = props => <div {...blockEverything} {...props} data-portal-trap='' />;
PortalEventTrap.displayName = 'PortalEventTrap';
